// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3RKw6","ranges":"BmiRanges_ranges__33vmU"};